import { api } from './client';
import type { BingDateGrain } from './bingDashboard';

export interface AppLikeOverviewRow {
  date_label: string;
  country?: string;
  traffic_type?: string;
  campaign_type?: string;
  customer_segmentation?: string;
  impressions: number;
  clicks: number;
  add_to_cart_count?: number;
  ctr: number;
  cpc: number;
  spend: number;
  cpm: number;
  purchases: number;
  revenue: number;
  cost_per_add_to_cart?: number;
  cpa: number;
  account_roi: number;
  aov: number;
  click_purchase_rate: number;
  click_add_to_cart_rate?: number;
  purchase_conversion_rate?: number;
}

export interface AppLikeOverviewResponse {
  list: AppLikeOverviewRow[];
  summary: AppLikeOverviewRow | null;
  region: string;
  site_code: string;
  start_date: string;
  end_date: string;
  date_grain: BingDateGrain;
  dimensions?: string[];
}

export interface AppLikeOverviewParams {
  brand_id: string;
  site_id: string;
  start_date: string;
  end_date: string;
  date_grain?: BingDateGrain;
}

interface ApiEnvelope<T> {
  code: number;
  message: string;
  data: T;
}

export const applovinDashboardApi = {
  getOverview: (params: AppLikeOverviewParams) =>
    api.get<ApiEnvelope<AppLikeOverviewResponse>>('/ad-dashboard/applovin/overview', { params }),
};
